// write bolier plate

import { ThemedText } from "@app/theme/Components"

import { ThemedView } from "@app/theme"
import { convertEpochToCustomFormat, INTEREST_REPAYMENT_STATUS } from "@app/utils"
import { InterestBounceType } from "@voltmoney/schema"
import dayjs from "dayjs"
import { ArrowUpRight, Warning,Info,WarningCircle } from '@app/sharedComponents/Icons/Icons';


const AwaitingMandateDesclaimer = () => {
    return (
        <ThemedView mx="lg" mb="lg" p="md" borderRadius="sm" flexDirection="row" justifyContent="center" flex={1} borderColor="border-warning" borderWidth={1} backgroundColor="bg-fill-warning">
            <Info size={16} weight="fill"  color="#f9bd21" style={{marginTop:2}}/>
            <ThemedView flexDirection="row" flex={1} flexWrap="wrap"  ml="sm">
                <ThemedText variant="b4r" color="text-secondary">
                    Auto-debit will still be attempted on your registered bank account. Any additional payments will be {''}
                <ThemedText variant="b4r" color="text-primary">
                adjusted to your balance.
                </ThemedText>
                </ThemedText>
            </ThemedView>
        </ThemedView>
    )
}

const InterestOverDueDeclaimer = () => {
    return (
        <ThemedView  backgroundColor="bg-fill-warning" mx="lg" mb="lg" p="md" borderRadius="sm" flexDirection="row" justifyContent="center" flex={1} borderColor="border-warning" borderWidth={1}>
            <Info size={16} weight="fill"  color="#f9bd21" style={{marginTop:2}}/>
            <ThemedView flexDirection="row" flex={1} flexWrap="wrap"  ml="sm">
                <ThemedText variant="b4r" color="text-primary">
                    Lender might have sold off the portfolio to recover the overdue amount. Any additional payments will be adjusted to your balance.
                </ThemedText>
            </ThemedView>
        </ThemedView>
    )
}

const InterestDueDeclaimer = ({bankDetails,autoPayDate}) => {
    return (
        <ThemedView mx="lg" mb="lg" p="md" borderRadius="sm" flexDirection="row" justifyContent="center" flex={1} borderColor="border-warning" borderWidth={1} backgroundColor="bg-fill-warning" >
            <Info size={16} weight="fill"  color="#f9bd21" style={{marginTop:2}}/>
            <ThemedView flexDirection="row" flex={1} flexWrap="wrap" ml="sm">
                <ThemedText variant="b4r" color="text-primary">
                    Auto-debit from <ThemedText variant='b4b' color='text-primary'>{bankDetails?.bankCode} XXXX {bankDetails?.accountNumber?.slice(-4)} </ThemedText>
                     is scheduled on <ThemedText variant='b4b' color='text-primary'>
                     {dayjs(autoPayDate).format('DD MMM, YYYY')}</ThemedText>. Any additional payments will be adjusted to your balance.
                </ThemedText>
            </ThemedView>
        </ThemedView>
    )
}

const InterestStatus = ({interestDetails,bankDetails,selectedAmount,firebaseParams}:any) => {
    const {interestStatus, isMandateSetup,autoPayDate,sellOffDate} = interestDetails;
    const  hardBreachDate = sellOffDate?new Date(sellOffDate).getDate():  15//
    const currentDate = firebaseParams?.follow_firebase_date==="true" ? dayjs(firebaseParams?.current_volt_date): dayjs()
    const isHardDateBreached = Number(currentDate?.format('DD')) >= hardBreachDate;
    return (
        <ThemedView>
        {(interestStatus === INTEREST_REPAYMENT_STATUS.AWAITING_MANDATE_STATUS && isMandateSetup && selectedAmount >=0) && <AwaitingMandateDesclaimer />}
        {(interestStatus === INTEREST_REPAYMENT_STATUS.OVERDUE && isHardDateBreached && selectedAmount >=0) && <InterestOverDueDeclaimer />}
        {(interestStatus === INTEREST_REPAYMENT_STATUS.DUE && isMandateSetup && selectedAmount >=0 ) && <InterestDueDeclaimer bankDetails={bankDetails} autoPayDate={autoPayDate} />}
        </ThemedView>
    )
}

export default InterestStatus;  